import React              from 'react';
import PropTypes          from 'prop-types';
import SelectComponent    from 'pu-react/components/base/SelectComponent';

const railWidthOptions = [
  {
    value: '',
    text : 'Select One',
  },
  {
    value: '0.250',
    text : '0.250"',
  },
  {
    value: '0.400',
    text : '0.400"',
  },
  {
    value: '0.500',
    text : '0.500"',
  },
];


class RailsWidth extends React.Component {
  render() {
    const disabled = this.props.parameters.rails_sides === 'no_sides';
    return (
      <SelectComponent
        label={this.props.label}
        name={this.props.name}
        onChange={e => this.props.onChangeParameter(this.props.name, e.target.value)}
        options={this.props.options}
        selected={this.props.parameters[this.props.name]}
        groupName={this.props.groupName}
        disabled={disabled} />
    );
  }
}

RailsWidth.defaultProps = {
  label    : 'Rail Width',
  options  : railWidthOptions,
  groupName: 'parameters',
  name     : 'rails_width',
};

RailsWidth.propTypes = {
  label            : PropTypes.string,
  groupName        : PropTypes.string,
  name             : PropTypes.string,
  onChangeParameter: PropTypes.func.isRequired,
  options          : PropTypes.arrayOf(PropTypes.object),
  parameters            : PropTypes.object.isRequired,
};

export default RailsWidth;
